import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { PagoRealizado } from "../../pago/index";
import { rules as rulesDocumentacion } from "./documentacion";

async function validarDocumentacion(x: models.DocumentacionServicios) {
    const rules = rulesDocumentacion();
    return !(await validation.hasError(validation.getErrors(rules, x)));
}

type Entity = models.PagoRealizadoModel;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    servicios: models.DocumentacionServicios;
    permisos: models.Rol;
    onAceptar: () => void;
}


/**
* Componente para editar un Entity
*/
export class PagoDocumentacion extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    servicios = (props: Props) => props.servicios;
    verPagoContado = (props: Props) => props.permisos.Documentacion.VerPagoContado;
    verPagoCredito = (props: Props) => props.permisos.Documentacion.VerPagoCredito;

    nuevoValue = createSelectorRx(this.value, this.verPagoContado, this.verPagoCredito, (value, verPagoContado, verPagoCredito) => ObtenerValuePago(value, verPagoContado, verPagoCredito));

    guias = createSelectorRx(this.servicios, async servicios => await validarDocumentacion(servicios) ? await resources.Documentacion.ObtenerGuias(servicios) : null);
    importes = createSelectorRx(this.guias, guia => nullsafe(guia, x => x.ImportesOrigen));
    idClienteOrigen = createSelectorRx(this.guias, guia => nullsafe(guia, x => x.IdClienteOrigen));
    importeTotal = createSelectorRx(this.importes, importes => nullsafe(importes, x => x.Total || 0));


    render() {
        const value = this.nuevoValue(this.props);
        const idCliente = this.idClienteOrigen(this.props);
        const importeTotal = this.importeTotal(this.props);
        const verPagoContado = this.verPagoContado(this.props);
        const verPagoCredito = this.verPagoCredito(this.props);

        return (
            <PagoRealizado
                {... this.props}
                value={value}
                idCliente={idCliente}
                importeAPagar={importeTotal}
                verPagoContado={verPagoContado}
                verPagoCredito={verPagoCredito}
            />
        );
    }
}

export function ObtenerValuePago(model: Entity, verPagoContado: boolean, verPagoCredito: boolean) {
    //La unica situación en la que se modifican los valores iniciales es cuando el usuario tiene solamente permiso de pago de credito y no el de contado
    if (verPagoCredito && !verPagoContado) {
        return { ...model, EsCredito: true } as Entity
    }
    else {
        return model
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/pago.tsx